module.exports = __webpack_public_path__ + "static/media/aaron-gillies.10090fed.jpg";